export default __webpack_public_path__ + "static/media/icone-infantil.dd9eb93b.png";